export default {
  myEvents: 'myEvents',
  participantEvents: 'participantEvents',
  awardUnitEvents: 'awardUnitEvents',
  awardEvents: 'awardEvents'
}
